import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BenchmarkCard = ({ title = '', children, bodyClassName = '', cardClassName = '', }) => {
    const bodyClasses = ['card-body', bodyClassName].filter(Boolean).join(' ');
    const cardClasses = ['card shadow', cardClassName].filter(Boolean).join(' ');
    return (_jsxs("div", { className: cardClasses, children: [title ? _jsx("h2", { className: 'card-header', children: title }) : null, _jsx("div", { className: bodyClasses, children: children })] }));
};
